export default __webpack_public_path__ + "assets/studio_small_08_1k.fa5d4349.hdr";